var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"value":_vm.active,"opacity":_vm.opacity,"absolute":_vm.absolute}},[_c('div',{staticClass:"earth"})])}
var staticRenderFns = []

export { render, staticRenderFns }